import * as React from 'react'
import { useState } from 'react'

interface Props {
	title: string
	onTitleChange: (newTitle: string) => void
	initialMaxClicks?: string
	initialMaxBudget?: string
	initialStartDate?: string
	initialEndDate?: string
	onFieldChange?: (field: string, value: string) => void
}

const AdGroupHeader = ({
	title,
	onTitleChange,
	initialMaxClicks = '',
	initialMaxBudget = '',
	initialStartDate = '',
	initialEndDate = '',
	onFieldChange,
}: Props) => {
	const [maxClicks, setMaxClicks] = useState(initialMaxClicks)
	const [maxBudget, setMaxBudget] = useState(initialMaxBudget)
	const [startDate, setStartDate] = useState(initialStartDate)
	const [endDate, setEndDate] = useState(initialEndDate)

	const handleTitleEdit = () => {
		const newTitle = prompt('Edit article title:', title)
		if (newTitle !== null) {
			onTitleChange(newTitle)
		}
	}

	const handleFieldChange = (field: string, value: string) => {
		switch (field) {
			case 'maxClicks':
				setMaxClicks(value)
				break
			case 'maxBudget':
				setMaxBudget(value)
				break
			case 'startDate':
				setStartDate(value)
				break
			case 'endDate':
				setEndDate(value)
				break
		}
		onFieldChange?.(field, value)
	}

	return (
		<div
			className="ad-group-header-and-status-section"
			style={{
				backgroundColor: '#F1F6F9',
				borderRadius: '8px',
				padding: '16px',
				marginBottom: '20px',
			}}
		>
			<div
				className="article-header-content"
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '4px',
				}}
			>
				<h4
					style={{
						fontFamily: 'ES Allianz, Arial, sans-serif',
						fontWeight: 500,
						fontSize: '16px',
						lineHeight: '1.5em',
						color: '#033542',
						margin: 0,
						cursor: 'pointer',
					}}
					onClick={handleTitleEdit}
				>
					{title}
				</h4>
				<button
					type="button"
					onClick={handleTitleEdit}
					style={{
						background: 'none',
						border: 'none',
						padding: '2px',
						cursor: 'pointer',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '24px',
						height: '24px',
					}}
					title="Edit title"
				>
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ color: '#00654D' }}>
						<path
							d="M3 14.25V15.75H4.5L11.8025 8.4475L10.3025 6.9475L3 14.25ZM13.4075 7.8425C13.5575 7.6925 13.5575 7.4575 13.4075 7.3075L12.1925 6.0925C12.0425 5.9425 11.8075 5.9425 11.6575 6.0925L10.6825 7.0675L12.1825 8.5675L13.4075 7.8425Z"
							fill="currentColor"
						/>
					</svg>
				</button>
			</div>

			{/* Ad Group Form Fields */}
			<div
				style={{
					backgroundColor: '#F1F6F9',
					borderRadius: '6px',
					marginTop: '10px',
					padding: '16px',
					overflow: 'hidden',
				}}
			>
				<div style={{ padding: '0' }}>
					{/* All fields in single row */}
					<div
						style={{
							display: 'flex',
							gap: '12px',
							width: '100%',
							minWidth: 0,
						}}
					>
						<div style={{ flex: 1, minWidth: 0 }}>
							<div
								style={{
									backgroundColor: '#FFFFFF',
									border: '1px solid rgba(65, 80, 92, 0.5)',
									borderRadius: '4px',
									minWidth: 0,
								}}
							>
								<div
									style={{
										padding: '8px 10px 7px',
										display: 'flex',
										flexDirection: 'column',
										gap: '2px',
										minWidth: 0,
									}}
								>
									<label
										style={{
											fontFamily: 'ES Allianz, Arial, sans-serif',
											fontWeight: 500,
											fontSize: '10px',
											lineHeight: '1em',
											color: 'rgba(3, 53, 66, 0.6)',
											margin: 0,
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										Max. Clicks
									</label>
									<input
										type="text"
										value={maxClicks}
										onChange={(e) => handleFieldChange('maxClicks', e.target.value)}
										placeholder="No:"
										style={{
											border: 'none',
											outline: 'none',
											background: 'transparent',
											fontFamily: 'ES Allianz, Arial, sans-serif',
											fontWeight: 500,
											fontSize: '14px',
											lineHeight: '1.3em',
											color: 'rgba(3, 53, 66, 0.38)',
											padding: 0,
											minHeight: '20px',
											width: '100%',
											minWidth: 0,
										}}
									/>
								</div>
							</div>
						</div>

						<div style={{ flex: 1, minWidth: 0 }}>
							<div
								style={{
									backgroundColor: '#FFFFFF',
									border: '1px solid rgba(65, 80, 92, 0.5)',
									borderRadius: '4px',
									minWidth: 0,
								}}
							>
								<div
									style={{
										padding: '8px 10px 7px',
										display: 'flex',
										flexDirection: 'column',
										gap: '2px',
										minWidth: 0,
									}}
								>
									<label
										style={{
											fontFamily: 'ES Allianz, Arial, sans-serif',
											fontWeight: 500,
											fontSize: '10px',
											lineHeight: '1em',
											color: 'rgba(3, 53, 66, 0.6)',
											margin: 0,
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										Max Budget
									</label>
									<input
										type="text"
										value={maxBudget}
										onChange={(e) => handleFieldChange('maxBudget', e.target.value)}
										placeholder="USD:"
										style={{
											border: 'none',
											outline: 'none',
											background: 'transparent',
											fontFamily: 'ES Allianz, Arial, sans-serif',
											fontWeight: 500,
											fontSize: '14px',
											lineHeight: '1.3em',
											color: 'rgba(3, 53, 66, 0.38)',
											padding: 0,
											minHeight: '20px',
											width: '100%',
											minWidth: 0,
										}}
									/>
								</div>
							</div>
						</div>

						<div style={{ flex: 1, minWidth: 0 }}>
							<div
								style={{
									backgroundColor: '#FFFFFF',
									border: '1px solid rgba(65, 80, 92, 0.5)',
									borderRadius: '4px',
									minWidth: 0,
								}}
							>
								<div
									style={{
										padding: '8px 10px 7px',
										display: 'flex',
										flexDirection: 'column',
										gap: '2px',
										minWidth: 0,
									}}
								>
									<label
										style={{
											fontFamily: 'ES Allianz, Arial, sans-serif',
											fontWeight: 500,
											fontSize: '10px',
											lineHeight: '1em',
											color: 'rgba(3, 53, 66, 0.6)',
											margin: 0,
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										Start Date
									</label>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											minWidth: 0,
											gap: '4px',
										}}
									>
										<input
											type="text"
											value={startDate}
											onChange={(e) => handleFieldChange('startDate', e.target.value)}
											placeholder="From Today"
											style={{
												border: 'none',
												outline: 'none',
												background: 'transparent',
												fontFamily: 'ES Allianz, Arial, sans-serif',
												fontWeight: 500,
												fontSize: '14px',
												lineHeight: '1.3em',
												color: 'rgba(3, 53, 66, 0.38)',
												padding: 0,
												minHeight: '20px',
												flex: 1,
												minWidth: 0,
											}}
										/>
										<svg
											width="18"
											height="18"
											viewBox="0 0 24 24"
											fill="none"
											style={{
												color: 'rgba(65, 80, 92, 0.56)',
												cursor: 'pointer',
												flexShrink: 0,
											}}
										>
											<path
												d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>

						<div style={{ flex: 1, minWidth: 0 }}>
							<div
								style={{
									backgroundColor: '#FFFFFF',
									border: '1px solid rgba(65, 80, 92, 0.5)',
									borderRadius: '4px',
									minWidth: 0,
								}}
							>
								<div
									style={{
										padding: '8px 10px 7px',
										display: 'flex',
										flexDirection: 'column',
										gap: '2px',
										minWidth: 0,
									}}
								>
									<label
										style={{
											fontFamily: 'ES Allianz, Arial, sans-serif',
											fontWeight: 500,
											fontSize: '10px',
											lineHeight: '1em',
											color: 'rgba(3, 53, 66, 0.6)',
											margin: 0,
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										End Date
									</label>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											minWidth: 0,
											gap: '4px',
										}}
									>
										<input
											type="text"
											value={endDate}
											onChange={(e) => handleFieldChange('endDate', e.target.value)}
											placeholder="To Forever"
											style={{
												border: 'none',
												outline: 'none',
												background: 'transparent',
												fontFamily: 'ES Allianz, Arial, sans-serif',
												fontWeight: 500,
												fontSize: '14px',
												lineHeight: '1.3em',
												color: 'rgba(3, 53, 66, 0.38)',
												padding: 0,
												minHeight: '20px',
												flex: 1,
												minWidth: 0,
											}}
										/>
										<svg
											width="18"
											height="18"
											viewBox="0 0 24 24"
											fill="none"
											style={{
												color: 'rgba(65, 80, 92, 0.56)',
												cursor: 'pointer',
												flexShrink: 0,
											}}
										>
											<path
												d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AdGroupHeader
